/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  DeleteApiV1ClassroomdisciplineIdUsersPersonid202,
  DeleteApiV1ClassroomdisciplineIdUsersPersonid401,
  DeleteApiV1ClassroomdisciplineIdUsersPersonid404,
  DeleteApiV1ClassroomdisciplineIdUsersPersonidMutationResponse,
  DeleteApiV1ClassroomdisciplineIdUsersPersonidPathParams,
} from "../../types/classPlanningPeopleController/DeleteApiV1ClassroomdisciplineIdUsersPersonid.ts";

export const deleteApiV1ClassroomdisciplineIdUsersPersonidPathParamsSchema =
  z.object({
    id: z.coerce.number().int(),
    personId: z.coerce.number().int(),
  }) as unknown as ToZod<DeleteApiV1ClassroomdisciplineIdUsersPersonidPathParams>;

/**
 * @description (Accepted) Requisição aceita.
 */
export const deleteApiV1ClassroomdisciplineIdUsersPersonid202Schema =
  z.any() as unknown as ToZod<DeleteApiV1ClassroomdisciplineIdUsersPersonid202>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const deleteApiV1ClassroomdisciplineIdUsersPersonid401Schema =
  z.any() as unknown as ToZod<DeleteApiV1ClassroomdisciplineIdUsersPersonid401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const deleteApiV1ClassroomdisciplineIdUsersPersonid404Schema =
  z.any() as unknown as ToZod<DeleteApiV1ClassroomdisciplineIdUsersPersonid404>;

export const deleteApiV1ClassroomdisciplineIdUsersPersonidMutationResponseSchema =
  z.lazy(
    () => deleteApiV1ClassroomdisciplineIdUsersPersonid202Schema,
  ) as unknown as ToZod<DeleteApiV1ClassroomdisciplineIdUsersPersonidMutationResponse>;
